import React, { useState, useEffect } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import {Container,Typography,Autocomplete,TextField,Button,Table,TableBody,TableCell,TableContainer,TableHead,TableRow,Paper,} from "@mui/material";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { useNavigate } from "react-router-dom";
import { BASE_URL } from "../../App";
import { Download as DownloadIcon } from "@mui/icons-material";
const login_id = localStorage.getItem("LOGIN_ID");
const BRANCH_CODE = localStorage.getItem("BRANCH_CODE");



const RetailerReport = () => {
  const [schemes, setSchemes] = useState([]);
  const [selectedScheme, setSelectedScheme] = useState(null);
  const [reportData, setReportData] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchSchemes = async () => {
      try {
        Swal.fire({ title: "Loading schemes...", allowOutsideClick: false });
        Swal.showLoading();

        const res = await axios.post(`${BASE_URL}/getSchemesforRetailer`);
        Swal.close();

        if (res.data && res.data.length > 0) {
          const options = res.data.map((item) => ({
            label: item.scheme_id || "Unknown",
            value: item.scheme_id,
          }));
          setSchemes(options);
        } else {
          Swal.fire("Info", "No schemes found", "info");
        }
      } catch (error) {
        Swal.close();
        console.error("Error fetching schemes:", error);
        Swal.fire("Error", "Failed to load schemes", "error");
      }
    };

    fetchSchemes();
  }, []);

  const handleSubmit = async () => {
    if (!selectedScheme) {
      Swal.fire("Warning", "Please select a scheme", "warning");
      return;
    }

    try {
      Swal.fire({ title: "Fetching report...", allowOutsideClick: false });
      Swal.showLoading();

      const res = await axios.post(`${BASE_URL}/getReportforretailer`, {
        scheme_id: selectedScheme.value,
        login_id: login_id, 
        BRANCH: BRANCH_CODE,
      });
      
      Swal.close();

      if (res.data && res.data.length > 0) {
        setReportData(res.data);
      } else {
        setReportData([]);
        Swal.fire("Info", "No report data found", "info");
      }
    } catch (error) {
      Swal.close();
      console.error("Error fetching report:", error);
      Swal.fire("Error", "Failed to fetch report", "error");
    }
  };
  // const handleRedirectToExport = () => {
  //   window.open("/RetailerReportExcelDownload", "_blank");
  // };
  const handleRedirectToExport = () => {
    navigate("/home/Reports/Retailer_Report_Excel_Download");
  };
  const handleDownloadExcel = () => {
    if (reportData.length === 0) {
      Swal.fire("Info", "No data to download", "info");
      return;
    }

    const worksheet = XLSX.utils.json_to_sheet(reportData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Retailer Report");

    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });

    const data = new Blob([excelBuffer], { type: "application/octet-stream" });
    saveAs(data, "Retailer_Report.xlsx");
  };

  return (
    <Container maxWidth="xl" sx={{ mt: 4 }}>
      {/* <Typography variant="h5" gutterBottom>
        Retailer Report
      </Typography> */}

      <Autocomplete
        options={schemes}
        value={selectedScheme}
        onChange={(e, newValue) => setSelectedScheme(newValue)}
        getOptionLabel={(option) => option.label || ""}
        renderInput={(params) => (
          <TextField {...params} label="Select Scheme" variant="outlined" fullWidth />
        )}
        sx={{ mb: 2 }}
      />

      <div style={{ display: "flex", gap: "10px", marginBottom: "24px", flexWrap: "wrap" }}>
        <Button variant="contained" color="primary" onClick={handleSubmit}>
          Submit
        </Button>

        <Button
          variant="contained"
          color="success"
          onClick={handleDownloadExcel}
          disabled={reportData.length === 0}
        >
          Download Excel
        </Button>

      <Button
                 variant="contained"
                 color="success"
                 sx={{ marginTop: 2 }}
                 startIcon={<DownloadIcon />}
                 onClick={handleRedirectToExport}
               >
                 Download as Excel
               </Button>
      </div>
      {reportData.length > 0 && (
  <TableContainer component={Paper}>
    {/* <Table>
      ...
      <TableBody>
        {reportData.map((row, index) => (
          <TableRow key={index}>
            ...
          </TableRow>
        ))}
      </TableBody>
    </Table> */}
  </TableContainer>
)}


      {reportData.length > 0 && (
     <TableContainer component={Paper} sx={{ maxHeight: 400 }}>
     <Table stickyHeader>
       <TableHead>
       <TableRow sx={{ backgroundColor: "#ADD8E6" }}>
        <TableCell sx={{ fontWeight: 'bold',backgroundColor: "#ADD8E6",  }}>Retailer Number</TableCell>
        <TableCell sx={{ fontWeight: 'bold',backgroundColor: "#ADD8E6",  }}>Retailer Name</TableCell>
        <TableCell sx={{ fontWeight: 'bold',backgroundColor: "#ADD8E6",  }}>Serial No</TableCell>
        <TableCell sx={{ fontWeight: 'bold',backgroundColor: "#ADD8E6",  }}>Points</TableCell>
        <TableCell sx={{ fontWeight: 'bold',backgroundColor: "#ADD8E6", }}>Invoice No</TableCell>
        <TableCell sx={{ fontWeight: 'bold',backgroundColor: "#ADD8E6",}}>Invoice Date</TableCell>
      </TableRow>
    </TableHead>


         <TableBody>
           {reportData.length > 0 ? (
             reportData.map((row, index) => (
              <TableRow key={index}>
  <TableCell>{row.retailer_number}</TableCell>
  <TableCell>{row.retailer_name}</TableCell>
  <TableCell>{row.serial_no}</TableCell>
  <TableCell>{parseFloat(row.points || 0).toFixed(2)}</TableCell>
  <TableCell>{row.invno}</TableCell>
  <TableCell>{row.invoicedate}</TableCell>
</TableRow>

             ))
           ) : (
             <TableRow>
               <TableCell colSpan={14} align="center">
                 No data available
               </TableCell>
             </TableRow>
           )}
         </TableBody>
       </Table>
     </TableContainer>
     
      )}
    </Container>
  );
};

export default RetailerReport;
